import React, { Component } from 'react';
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  Box,
  Alert,
  Divider,
  Stack
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import SaveIcon from '@mui/icons-material/Save';

class PrinterSettings extends Component {
  constructor(props) {
    super(props);

    // Estado inicial do componente
    this.state = {
      printLocation: 'neste',  // 'balcao' | 'cozinha'
      agentType: 'navegador',    // 'navegador' | 'agente'
      connectionType: 'usb',    // 'usb' | 'ip'
      ipAddress: '',
      savedSuccess: false
    };
  }

  // Ao montar o componente, recupera os dados salvos no localStorage (se existirem)
  componentDidMount() {
    this.loadSettings();
  }

  // Função para ler as configurações salvas
  loadSettings = () => {
    try {
      const savedData = localStorage.getItem('printer_settings');
      if (savedData) {
        const parsed = JSON.parse(savedData);
        this.setState({
          printLocation: parsed.printLocation || 'balcao',
          agentType: parsed.agentType || 'navegador',
          connectionType: parsed.connectionType || 'usb',
          ipAddress: parsed.ipAddress || ''
        });
      }
    } catch (error) {
      console.error('Erro ao carregar configurações do localStorage:', error);
    }
  };

  // Handler genérico para atualização do estado
  handleChange = (field) => (event) => {
    this.setState({
      [field]: event.target.value,
      savedSuccess: false
    });
  };

  // Função para salvar todas as preferências no localStorage
  handleSave = (e) => {
    e.preventDefault();

    const settingsToSave = {
      printLocation: this.state.printLocation,
      agentType: this.state.agentType,
      connectionType: this.state.agentType === 'agente' ? this.state.connectionType : null,
      ipAddress: this.state.agentType === 'agente' && this.state.connectionType === 'ip' ? this.state.ipAddress : ''
    };

    try {
      localStorage.setItem('printer_settings', JSON.stringify(settingsToSave));
      this.setState({ savedSuccess: true });

      // Oculta a mensagem de sucesso após 3 segundos
      setTimeout(() => {
        this.setState({ savedSuccess: false });
      }, 3000);
    } catch (error) {
      console.error('Erro ao salvar no localStorage:', error);
    }
  };

  render() {
    const { printLocation, agentType, connectionType, ipAddress, savedSuccess } = this.state;

    return (
      <Box sx={{ maxWidth: 500, margin: '2rem auto', padding: 2 }}>
        <Card elevation={3}>
          <CardContent>
            <Typography variant="h5" component="h2" gutterBottom align="center">
              Configuração de Impressão
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={this.handleSave}>
              <Stack spacing={3}>

                {/* 1. Pergunta: Onde deseja fazer a impressão? */}
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>
                    1. Onde deseja fazer a impressão?
                  </FormLabel>
                  <RadioGroup
                    row
                    value={printLocation}
                    onChange={this.handleChange('printLocation')}
                  >
                    <FormControlLabel value="neste" control={<Radio />} label="Neste Dispositivo" />
                    <FormControlLabel value="balcao" control={<Radio />} label="Balcão" />
                    <FormControlLabel value="cozinha" control={<Radio />} label="Cozinha" />
                  </RadioGroup>
                </FormControl>

                {/* 2. Pergunta: Tipo de Impressão */}

                {printLocation == "neste" && <> <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>
                    2. Método de Impressão
                  </FormLabel>
                  <RadioGroup
                    value={agentType}
                    onChange={this.handleChange('agentType')}
                  >
                    <FormControlLabel value="navegador" control={<Radio />} label="Impressão pelo Navegador" />
                    <FormControlLabel value="agente" control={<Radio />} label="Agente Local" />
                  </RadioGroup>
                </FormControl></>}


                {/* 3. Condicional: Opções do Agente Local */}
                {agentType === 'agente' && printLocation == "neste" && (
                  <Box sx={{ pl: 2, borderLeft: '3px solid #1976d2' }}>
                    <FormControl component="fieldset" margin="normal">
                      <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>
                        Tipo de Conexão do Agente
                      </FormLabel>
                      <RadioGroup
                        row
                        value={connectionType}
                        onChange={this.handleChange('connectionType')}
                      >
                        <FormControlLabel value="usb" control={<Radio />} label="USB" />
                        <FormControlLabel value="ip" control={<Radio />} label="Rede (IP)" />
                      </RadioGroup>
                    </FormControl>

                    {/* 4. Condicional: Digitar o IP se a conexão for IP */}
                    {connectionType === 'ip' && (
                      <TextField
                        fullWidth
                        label="Endereço IP da Impressora/Agente"
                        placeholder="Ex: 192.168.1.100"
                        value={ipAddress}
                        onChange={this.handleChange('ipAddress')}
                        margin="normal"
                        variant="outlined"
                        required={connectionType === 'ip'}
                      />
                    )}
                  </Box>
                )}

                {/* Mensagem de confirmação */}
                {savedSuccess && (
                  <Alert severity="success">Configurações salvas no localStorage com sucesso!</Alert>
                )}

                {/* Botão para Salvar */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<SaveIcon />}
                  fullWidth
                >
                  Salvar Configurações
                </Button>
              </Stack>
            </form>
          </CardContent>
        </Card>
      </Box>
    );
  }
}

export default PrinterSettings;